import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import { Textarea, Select } from "../../../../form-inputs/inputs";
import { Typeahead } from "../../../../form-inputs/typeahead";
import { getPicklist } from "../lib/data";

const DEFAULT_FOOTNOTE = {
    noteMark: "",
    text: "",
};

const Footnotes = (props) => {
    const [presets, setPresets] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState("");

    useEffect(() => {
        async function fetchData() {
            const response = await getPicklist("FootnotePresets");

            if (!response) {
                return;
            }

            setPresets(response);
        }

        fetchData();
    }, []);

    const addFootnote = (e) => {
        e.preventDefault();
        props.updateField("footnotes", [...props.data.items, DEFAULT_FOOTNOTE]);
    };

    const removeFootnote = (index) => {
        const newFootnotes = [...props.data.items];
        newFootnotes.splice(index, 1);
        props.updateField("footnotes", newFootnotes);
    };

    const updateFootnoteMark = (name, value, index) => {
        const newFootnotes = [...props.data.items];
        newFootnotes[index] = { ...newFootnotes[index], noteMark: value };
        props.updateField("footnotes", newFootnotes);
        document.getElementsByName(name)[0].focus();
    };

    const updateFootnoteText = (name, value, index) => {
        const newFootnotes = [...props.data.items];
        newFootnotes[index] = { ...newFootnotes[index], text: value };
        props.updateField("footnotes", newFootnotes);
    };

    const onSelect = (name, value) => {
        const selectedPreset = presets.find((p) => p.value.toString() === value);

        if (selectedPreset && selectedPreset.placeHolderText) {
            props.updateField("footnotes", [
                ...props.data.items,
                {
                    noteMark: "",
                    text: selectedPreset.placeHolderText,
                },
            ]);
        }

        setSelectedTemplate("");
    };

    const presetSelectHtml = props.presets ? (
        <Select name="footerTemplate" value={selectedTemplate} updateOnChange={onSelect} options={presets} />
    ) : null;
    const footnotes = props.data.items.map((footnote, index) => {
        return (
            <div key={`${index}_${props.data.length}`} className="footnote">
                <div
                    className="close"
                    onClick={(e) => {
                        removeFootnote(index);
                    }}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
                <div className="input-group">
                    <Typeahead
                        name={`m${index}`}
                        defaultValue={footnote.noteMark}
                        options={props.noteMarkList}
                        updateOnChange={(name, value) => {
                            updateFootnoteMark(name, value, index);
                        }}
                        className="-x-small"
                    />
                    <Textarea
                        name={`f${index}`}
                        value={footnote.text}
                        updateOnChange={(name, value) => {
                            updateFootnoteText(name, value, index);
                        }}
                    />
                </div>
            </div>
        );
    });

    return (
        <div className="footnotes">
            <h3>Footnotes</h3>
            {presetSelectHtml}
            {footnotes}
            <button className="button -primary -small" onClick={addFootnote}>
                <FontAwesomeIcon icon={faPlus} /> Footnote
            </button>
        </div>
    );
};

export default Footnotes;
